<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col>
                <LocationTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import LocationTable from '@/components/lists/derived/LocationTable'
export default {
    name:'LocationPage',
    components:{
        LocationTable
    }
}
</script>